import { render } from "./PatientCreate.vue?vue&type=template&id=4e0e0a4a"
import script from "./PatientCreate.vue?vue&type=script&lang=js"
export * from "./PatientCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\dynalist-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__